import * as pdfjsLib from 'pdfjs-dist';

import type { PDFDocumentProxy } from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

const MAX_THUMBNAIL_WIDTH = 400;

/**
 * Render the first page of a PDF file as a data URL thumbnail.
 * Returns null if rendering fails (caller should fall back to icon).
 */
export async function renderPdfThumbnail(file: File): Promise<string | null> {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdf: PDFDocumentProxy = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);

    const unscaledViewport = page.getViewport({ scale: 1 });
    const scale = MAX_THUMBNAIL_WIDTH / unscaledViewport.width;
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvas, viewport }).promise;
    const dataUrl = canvas.toDataURL('image/png');

    page.cleanup();
    await pdf.destroy();

    return dataUrl;
  } catch {
    return null;
  }
}
